import React from "react";
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, styled } from "@mui/material";

import FilterListItem from "../FilterListItem";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 140,
}));

export interface YearRangeFilterProps {
  title: string;
  name?: string;
  tooltip?: string;
  startDate?: number;
  endDate?: number;
  value: (number | null)[];
  disabled?: boolean;
  open?: boolean;
  setOpen: (open: boolean) => void;
  onChange: (value: (number | null)[]) => void;
}

const YearRangeFilter: React.FC<YearRangeFilterProps> = ({
  title = "Date Range Filter",
  name = "date-range-filter",
  tooltip,
  //startDate = 0,
  //endDate = new Date(new Date().getFullYear()).getTime(),
  value = [null, null],
  disabled,
  open,
  setOpen,
  onChange,
}) => {
  const [fromDate, toDate] = value;
  const [startDate, setstartDate] = React.useState(2010);
  const [endDate, setendDate] = React.useState(new Date(new Date().getFullYear()).getTime());
  const handleChange = (event: any) => {
    setstartDate(event.target.value);
    onChange([event.target.value, endDate]);
  };
  const handleChange2 = (event: any) => {
    setendDate(event.target.value);
    onChange([startDate, event.target.value]);
  };

  const generateYears = (startYear: number) => {
    const years = [];
    for (var i = startYear; i <= new Date().getFullYear(); i++) {
      years.push(i);
    }
    return years;
  };

  const yearOptions = generateYears(2010);

  return (
    <FilterListItem title={title} tooltip={tooltip} selected={0} open={open} setOpen={setOpen}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 6 }} style={{ flex: 1 }}>
          <StyledFormControl variant="filled" style={{ width: "100%" }}>
            <InputLabel id="startYear">Start Year</InputLabel>
            <Select labelId="startYear" id={`${name}-from`} value={startDate} onChange={handleChange}>
              {yearOptions.map(option => (
                <MenuItem key={`m1${option}`} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </Grid>
        <Grid size={{ xs: 6 }} style={{ flex: 1 }}>
          <StyledFormControl variant="filled" style={{ width: "100%" }}>
            <InputLabel id="endYear">End Year</InputLabel>
            <Select labelId="endYear" id={`${name}-to`} value={endDate} onChange={handleChange2}>
              {yearOptions.map(option => (
                <MenuItem key={`m2${option}`} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </Grid>
      </Grid>
      <Box paddingTop={4}>
        <Button
          id={`${name}-clear`}
          variant="outlined"
          size="small"
          disabled={disabled || (fromDate === null && toDate === null)}
          onClick={() => {
            onChange([null, null]);
          }}
        >
          Clear
        </Button>
      </Box>
    </FilterListItem>
  );
};

export default YearRangeFilter;
